import { render, staticRenderFns } from "./OpenRtbListBlock.vue?vue&type=template&id=0fa05372&scoped=true&"
import script from "./OpenRtbListBlock.vue?vue&type=script&lang=js&"
export * from "./OpenRtbListBlock.vue?vue&type=script&lang=js&"
import style0 from "./OpenRtbListBlock.vue?vue&type=style&index=0&id=0fa05372&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa05372",
  null
  
)

export default component.exports